
function modifyShopBtn() {
    var sheet = new CSSStyleSheet;
    // sheet.replaceSync( `button { color: pink !important; }`);
    // const host = document.querySelector('shop-pay-wallet-button')
    // host.shadowRoot.adoptedStyleSheets.push(sheet);
}

setTimeout(() => {
    modifyShopBtn()
}, 1500)

document.addEventListener('DOMContentLoaded', function() {
    findAndHideDefaultChatOpenBtn(10)
    customChatBtnListener()
})

function customChatBtnListener() {
    const chatBtn = document.querySelectorAll('.style-2-footer-customer-wrapper .chat-btn')
    if (chatBtn.length) {
        chatBtn.forEach(btn => {
            btn.addEventListener('click', function(event) {
                event.preventDefault();
                try {
                    const shopifyChatHost = document.querySelector('inbox-online-store-chat');
                    if (shopifyChatHost && shopifyChatHost.shadowRoot) {
                    const closeBtn = shopifyChatHost.shadowRoot.querySelector(".chat-app--close-button")
                    if(closeBtn) {
                        closeBtn.click()
                    }
                    const chatToggleButton = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
                    if (chatToggleButton) {
                        chatToggleButton.click();
                        chatToggleButton.style.display = 'none'
                    } else {
                        console.error('Shopify Inbox: Internal chat toggle button not found.');
                    }
                    } else {
                    console.error('Shopify Inbox: Chat host element not found or shadowRoot not accessible.');
                    }
                } catch (error) {
                    console.error('Error programmatically opening Shopify Inbox:', error);
                }
            });
        });
    }
}

function findAndHideDefaultChatOpenBtn(maxTries = 10) {
  let attempts = 0;

  const interval = setInterval(() => {
    try {
      attempts++;

      // Safely try to get the chat host element
      let shopifyChatHost;
      try {
        shopifyChatHost = document.querySelector('inbox-online-store-chat');
      } catch (err) {
        console.warn('Error accessing chat host:', err);
        shopifyChatHost = null;
      }

      // Agar element hi nahi mila toh skip karo
      if (!shopifyChatHost || !shopifyChatHost.shadowRoot) {
        if (attempts >= maxTries) {
          console.log(`Chat host not found after ${maxTries} attempts`);
          clearInterval(interval);
        }
        return;
      }

      // Shadow DOM me style inject karte waqt safety
      try {
        const style = document.createElement('style');
        style.innerHTML = 'button.chat-toggle { display: none !important; }';
        shopifyChatHost.shadowRoot.appendChild(style);
      } catch (err) {
        console.warn('Error injecting style in shadowRoot:', err);
      }

      // Button element safely check karo
      let element = null;
      try {
        element = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
      } catch (err) {
        console.warn('Error querying button inside shadowRoot:', err);
      }

      if (element) {
        try {
          element.style.display = 'none';
          console.log(`✅ Element found and hidden after ${attempts} attempts`);
          clearInterval(interval);
          return true;
        } catch (err) {
          console.warn('Error hiding element:', err);
        }
      }

      // Retry limit check
      if (attempts >= maxTries) {
        console.log(`❌ Element not found after ${maxTries} attempts`);
        clearInterval(interval);
        return false;
      }
    } catch (err) {
      console.error('Unexpected error in findAndHideDefaultChatOpenBtn:', err);
      clearInterval(interval);
    }
  }, 200); // Check every 200ms
}


$(document).ready(function(){
    $('body').on('click', '.quick-add-modal .content-tabs__tab', function(e){
        e.preventDefault();
        $('.quick-add-modal .content-tabs__tab').removeClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content').removeClass('content-tabs__content--active');
        var getId = $(this).attr('data-content-tab-id');
        $('.quick-add-modal .content-tabs__tab[data-content-tab-id="'+getId+'"]').addClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content[data-content-tab-id="'+getId+'"]').addClass('content-tabs__content--active');
    });

    $('body').on('click', '.drawer__header-close', function(){
      $('body').removeClass('overflow-hidden');
    });

    $('body').on('click', '.variantImageSlider .swiper-slide', function(){
        var index = $(this).attr('data-index');
        if (window.mainSwiperPop && window.mainSwiperPop.slideTo) {
            window.mainSwiperPop.slideTo(index); // 3rd slide pe jump karega
        }
        $('.proImageSliderVariant').removeClass('hide');
    });

    $('body').on('click', '.popVariantClose', function(){
        $('.proImageSliderVariant').addClass('hide');
    });

    $('.video-slider .mineBtnMine').click(function(e){
        e.preventDefault();
        if($(this).hasClass('swiper-button-prev')){
            $('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-next').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-next').removeClass('disableMine');
            }
        }else{
            $('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-prev').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-prev').removeClass('disableMine');
            }
        }
    });

    $('#insta-feed h2').wrapAll('<div class="instaWrapHeader"></div>');

    var widthWindow = $(window).width();

    if(widthWindow > 768){
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'SaQKP4']);
        });
    }else{
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'WkrmxQ']);
        });
    }
});